import classNames from 'classnames';
import React from 'react';

import styles from './text-input.module.css';

type TextInputProps = React.ComponentProps<'input'> & {
  rightIcon?: React.ReactNode;
};

export function TextInput({ rightIcon, ...inputProps }: TextInputProps) {
  return (
    <div className={classNames(styles.inputContainer, inputProps.className)}>
      <input type="text" {...inputProps} className={styles.input} />
      {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}
    </div>
  );
}
